import $ from 'jquery';

export function toggleParent(event, parent){
   
    $(event).on('click', function(){
        $(this).toggleClass('open');
        $(this).parent(parent).toggleClass('open');
    })
}


// WEBPACK FOOTER //
// app/scripts/components/toggle-parent.js